import React from 'react';

interface IconProps {
  color?: string;
}

function Icon({ color = '#ffffff' }: IconProps): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M15 9l-6 6M9 9l6 6"
      ></path>
    </svg>
  );
}

export default Icon;
